(function () {
  if (window.__nvColor) return;
  window.__nvColor = true;

  // Swap in the real review images (they wait in data-src / data-srcset).
  // The first few load straight away; the rest stay lazy until the strip is
  // swiped, then load together so the next cards are ready.
  var EAGER = 5;
  function loadImages(box) {
    box.querySelectorAll('img[data-src]').forEach(function (img, index) {
      if (index < EAGER) img.loading = 'eager';
      if (img.dataset.srcset) img.srcset = img.dataset.srcset;
      img.src = img.dataset.src;
      img.removeAttribute('data-src');
      img.removeAttribute('data-srcset');
    });
  }
  function loadAll(box) {
    box.querySelectorAll('img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  }

  // Review strip: images load once the strip is near, arrow buttons scroll by
  // one card, a card opens the full image large.
  function initReviews(root) {
    (root || document).querySelectorAll('[data-nvc-reviews]').forEach(function (box) {
      if (box.__ready) return;
      box.__ready = true;
      var scroller = box.querySelector('.nvc-reviews__scroller');
      var dialog = box.querySelector('dialog');
      var big = dialog.querySelector('img');
      var reduce = matchMedia('(prefers-reduced-motion: reduce)');

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          if (!entries.some(function (entry) { return entry.isIntersecting; })) return;
          observer.disconnect();
          loadImages(box);
        }, { rootMargin: '600px 0px' });
        observer.observe(box);
      } else {
        loadImages(box);
      }
      scroller.addEventListener('scroll', function () {
        if (!box.querySelector('img[data-src]')) loadAll(box);
      }, { passive: true, once: true });

      box.querySelectorAll('[data-nvc-step]').forEach(function (button) {
        button.addEventListener('click', function () {
          var card = scroller.querySelector('.nvc-review');
          var step = card ? card.getBoundingClientRect().width + 16 : 240;
          scroller.scrollBy({ left: step * Number(button.dataset.nvcStep), behavior: reduce.matches ? 'auto' : 'smooth' });
        });
      });

      scroller.addEventListener('click', function (event) {
        var card = event.target.closest('.nvc-review');
        if (!card) return;
        var img = card.querySelector('img');
        big.src = img.dataset.full || img.currentSrc || img.src;
        big.alt = img.alt;
        dialog.showModal();
      });

      dialog.addEventListener('click', function (event) {
        if (event.target === dialog) dialog.close();
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { initReviews(); });
  } else {
    initReviews();
  }
  document.addEventListener('shopify:section:load', function (e) { initReviews(e.target); });
})();
